// Material Icons (Apache-2.0), generated from @mui/icons-material Menu — do not edit by hand.
import { createSvgIcon } from '../SvgIcon';

export default createSvgIcon(<path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" />, 'Menu');
